import React from "react";
import { BaseSegmentListViewProps } from "./SegmentListView";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { SegmentListChip } from "./SegmentListChip";

export function SegmentListChipsView (props: BaseSegmentListViewProps): JSX.Element
{
    function handleClick (identifier: string, selected: boolean)
    {
        if (props.onToggleSelect)
            props.onToggleSelect(identifier, selected);
    }

    const shownSegmentLists = React.useMemo(() => {
        if (props.onToggleSelect) {
            return props.segmentLists;
        }
        else {
            return props.segmentLists.filter(sl => sl.selected);
        }
    }, [props.segmentLists, props.onToggleSelect]);

    return (
        <section>
            <Flex gap={4} style={{ flexWrap: 'wrap' }}>
                {shownSegmentLists.map((l, index) =>
                    <SegmentListChip key={l.identifier + '_' + index}
                        identifier={l.identifier}
                        segments={l.segments}
                        selected={l.selected}
                        answerCount={props.displayAnswerCount ? l.answerCount : undefined}
                        onClick={props.onToggleSelect ? handleClick : undefined} />
                )}
            </Flex>
        </section>
    );
}